import { FaSolidWrench } from "solid-icons/fa"
import { Component, createSignal, For, Show } from "solid-js"
import { Dynamic } from "solid-js/web"
import type { Nullable } from "vite-node"
import FillTool from "./FillTool/FillTool"
import RownipulatorTool from "./RownipulatorTool/RownipulatorTool"

const ToolsWidget: Component = () => {
  // const engine: Engine = useContext(EngineContext)

  const tools = [
    { dname: 'Rownipulator', fn: RownipulatorTool },
    { dname: 'Fill', fn: FillTool },
    // { dname: 'Fill', fn() { return 'Fill' } },
  ]

  const [getSelectedTool, setSelectedTool] = createSignal<Nullable<typeof tools[number]>>()

  // createEffect(() => {
  //   console.log('getSelectedTool', getSelectedTool())
  // })

  // onMount(() => {
  //   console.log('ToolsWidget.onMount.setSelectedTool.tools[0]')
  //   setSelectedTool(tools[0])
  // })

  return <div id="MapEditorToolsWidget" class="card-body">
    <div class="input-group">
      <span class="input-group-text">
        <FaSolidWrench />
      </span>
      <select name="selected_tool" class="form-select" aria-label="Select Tool"
        aria-placeholder="Select Tool"
        onChange={(event) => {
          setSelectedTool(tools[parseInt(event.currentTarget.value)])
        }}
      >
        <option selected={!getSelectedTool()} disabled aria-disabled>Select Tool</option>
        <For each={tools}>{(tool, index) => {
          return <option selected={getSelectedTool() === tool} value={index()}>
            {tool.dname}
          </option>
        }}</For>
      </select>
    </div>
    <Show when={getSelectedTool()}
      // fallback={<div>No tool selected</div>}
      children={(selectedTool) => <>
        <hr />
        <Dynamic component={selectedTool().fn} />
      </>}
    />
  </div>
}

export default ToolsWidget
